import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";

@Component({
  selector: 'app-factors',
  standalone: false,
  templateUrl: './factors.component.html',
  styleUrls: ['./factors.component.scss']
})
export class FactorsComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Info', 'Price', 'UserId'];
  displayDataSources = ['info', 'Price', 'UserId'];
  displayColumnTypes = ['event', 'number', 'string'];
  displayEndPoint = [this.ServicePath.GET_MY_FACTORS, '', ''];
  factors: any = [];
  allFilters = FilterUtil.FactorsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getFactors(this.tableProperties.offset, this.tableProperties.limit, 'User', undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.factors = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.factors) {
      for (let i = 0; i < this.factors.length; i++) {
        this.factors[i].info = (index: number) => {
          this.onInfoClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onInfoClicked(index: number) {
  }
}
